module.exports = __webpack_public_path__ + "img/1.c330b9fc.png";